import createSeekBar from './mediaplayer-seekbar.js';

class MediaPlayer {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.video = this.el.querySelector('video');
    this.seekBar = this.el.querySelector('input.seekbar');
    this.playBtn = this.el.querySelector('button.play');
    this.soundBtn = this.el.querySelector('button.sound');
    this.controls = this.el.querySelector('.mediacontrols');

    if (this.seekBar) {
      createSeekBar(this.video, this.seekBar);
    }
    this.updateState();

    this.video.addEventListener('playing', this.updateState.bind(this));
    this.video.addEventListener('pause', this.updateState.bind(this));

    this.playBtn.addEventListener('click', function(event) {
      event.stopPropagation();
      this.togglePlay();
    }.bind(this));

    if(this.soundBtn) {
      //console.log(this.soundBtn);
      this.soundBtn.addEventListener('click', function(event) {
        event.stopPropagation();
        this.toggleSound();
      }.bind(this));
    }

    this.seekBar.addEventListener('click', function() {
      event.stopPropagation();
    }.bind(this));

    // this.controls.addEventListener('click', function() {
    //   this.togglePlay();
    // }.bind(this));
  }
  togglePlay() {
    if(this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }
  toggleSound() {
    if(this.video.muted) {
      this.video.muted = false;
    } else {
      this.video.muted = true;
    }
    this.updateState();
  }
  updateState() {
    if(this.video.paused) {
      this.el.setAttribute('data-video-state', 'paused');
    } else {
      this.el.setAttribute('data-video-state', 'playing');
    }
    if(this.video.muted) {
      this.el.setAttribute('data-video-sound', 'off');
    } else {
      this.el.setAttribute('data-video-sound', 'on');
    }
  }
}

export default function () {
  var players = document.querySelectorAll('.mediaplayer');

  Array.from(players).forEach(function(item, index) {
    var player = new MediaPlayer(item);
  })
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/mediaplayer.js